import { TUserRole } from '../../types/currentUser';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EUserRoleActionTypes {
  SetUserRole = 'userRole/set',
}

export type TSetUserRole = ITypedReduxAction<EUserRoleActionTypes.SetUserRole, TUserRole>;

export const setUserRole: (userRole: TUserRole) => TSetUserRole = actionGenerator<
  EUserRoleActionTypes.SetUserRole,
  TUserRole
>(EUserRoleActionTypes.SetUserRole);
